module.exports = __webpack_public_path__ + "img/social-wa.4fb16a96.png";